import { MenuGuard } from './menu.guard';
import { AuthPagesGuard } from './auth-pages.guard';
import { NetworkingGuard } from './networking.guard';

export const GUARDS = [
  MenuGuard,
  AuthPagesGuard,
  NetworkingGuard,
];
